
export enum ESendBy {
    user = 'user',
    bot = 'bot',
    owner = 'owner',
    finder = 'Finder'
  }
